import { render, staticRenderFns } from "./add-subcription-modal-resource.vue?vue&type=template&id=fd65f542&scoped=true"
import script from "./add-subcription-modal-resource.vue?vue&type=script&lang=ts"
export * from "./add-subcription-modal-resource.vue?vue&type=script&lang=ts"
import style0 from "./add-subcription-modal-resource.vue?vue&type=style&index=0&id=fd65f542&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd65f542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd65f542')) {
      api.createRecord('fd65f542', component.options)
    } else {
      api.reload('fd65f542', component.options)
    }
    module.hot.accept("./add-subcription-modal-resource.vue?vue&type=template&id=fd65f542&scoped=true", function () {
      api.rerender('fd65f542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/Modal/add-subcription-modal-resource.vue"
export default component.exports